import studioGlobal from './studioGlobal.svg';
import studioGlobalLogo from './studioGlobalLogo.svg';
export { studioGlobal, studioGlobalLogo, };
